import { registerLocaleData } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import localeCA from '@angular/common/locales/ca';
import localeDE from '@angular/common/locales/de';
import localeEL from '@angular/common/locales/el';
import localeEN from '@angular/common/locales/en';
import localeES from '@angular/common/locales/es';
import localeDO from '@angular/common/locales/es-DO';
import localeFR from '@angular/common/locales/fr';
import localeIT from '@angular/common/locales/it';
import localePT from '@angular/common/locales/pt';
import localeTR from '@angular/common/locales/tr';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { Auth0Client } from '@auth0/auth0-spa-js';
import { Auth0ClientFactory } from '@shared/services/auth0-client.factory';
import { AuthInterceptor } from '@shared/interceptors/auth-interceptor';
import { BavelAccountModule } from './account/bavel-account.module';
import { BavelGlobalizationModule } from '@globalization/bavel-globalization.module';
import { BavelLogsModule } from '@logs/bavel-logs.module';
import { BavelSharedModule } from '@shared/shared.module';
import { BavelToolModule } from '@tool/tool.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserNotSupportedComponent } from '@shared/components/error-pages/browser-not-supported/browser-not-supported.component';
import { ConfirmationService, MessageService } from 'primeng/api';
import { CookieModule, CookieService } from 'ngx-cookie';
import { LogService } from '@logs/services/log.service';
import { myCustomPreset } from '../styles/myCustomPreset';
import { NgIdleModule } from '@ng-idle/core';
import { NgModule } from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import { ToastModule } from 'primeng/toast';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslationService } from '@globalization/services/translation.service';

registerLocaleData(localeDO);
registerLocaleData(localeES);
registerLocaleData(localeCA);
registerLocaleData(localeEN);
registerLocaleData(localePT);
registerLocaleData(localeFR);
registerLocaleData(localeDE);
registerLocaleData(localeTR);
registerLocaleData(localeEL);
registerLocaleData(localeDO);
registerLocaleData(localeIT);

@NgModule({
  declarations: [
    AppComponent,
    BrowserNotSupportedComponent
  ],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    NgIdleModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useClass: TranslationService,
        deps: [HttpClient, CookieService, LogService]
      }
    }),
    CookieModule.forRoot(),
    BavelAccountModule,
    AppRoutingModule,
    BavelGlobalizationModule,
    BavelLogsModule,
    BavelSharedModule.forRoot(),
    BavelToolModule,
    ToastModule
  ],
  providers: [
    ConfirmationService,
    MessageService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: myCustomPreset,
        options: {
          darkModeSelector: false
        }
      }
    }),
    {
      provide: Auth0Client,
      useFactory: (factory: Auth0ClientFactory): Auth0Client => factory.create(),
      deps: [Auth0ClientFactory]
    }
  ]
})
export class AppModule { }
